import { DtBillCreationProcessEntity, DtBillWritebackProcessEntity } from '@edp-bif/common-api';
import { ResponseToolbarComponent, ResponseToolbarClickEvent } from '@farris/ui-response-toolbar';
import { DatagridComponent, DataColumn } from '@farris/ui-datagrid';
import { TemplateRef, Injector, ComponentFactoryResolver, ChangeDetectorRef, OnInit, EventEmitter } from '@angular/core';
import { MessagerService } from '@farris/ui-messager';
import { NotifyService } from '@farris/ui-notify';
import { GSPMetadataRTService } from '@gsp-lcm/metadatart-selector';
import { BsModalService } from '@farris/ui-modal';
import { AifLocalePipe } from '../aif-ui-common/pipe/aif-ui-common-locale.pipe';

export abstract class AbstractDatagridComponent implements OnInit {
    readonly groupIcon = '<i class="f-icon f-icon-lookup"></i>';

    toolbar: ResponseToolbarComponent;
    readonly toolbarData = [
        {
            id: 'btn-add',
            text: this.localePipe.instant("add"),
            class: 'btn btn-secondary',
            disabled: false
        },
        {
            id: 'btn-remove',
            text: this.localePipe.instant("remove"),
            class: 'btn btn-secondary',
            disabled: false
        },
    ];

    dg: DatagridComponent;
    dgIdField: string = "id";
    dgColumns: DataColumn[];
    abstract get dgData(): Array<any>;
    abstract set dgData(arr: Array<any>);
    get dgTotal(): number {
        return this.dgData.length || 0;
    }

    dgIsEnabledStateCell: TemplateRef<any>;
    dgOpCell: TemplateRef<any>;
    editingRowId: string = null;

    constructor(
        protected messager: MessagerService,
        protected notify: NotifyService,
        protected metadataService: GSPMetadataRTService,
        protected modalService: BsModalService,
        protected localePipe: AifLocalePipe,
        protected injector: Injector,
        protected resolver: ComponentFactoryResolver,
        protected cdf: ChangeDetectorRef,
    ) {

    }

    abstract ngOnInit(): void;

    toolbarClickHandler(args: ResponseToolbarClickEvent) {
        switch (args.id) {
            case 'btn-add':
                this.add();
                break;
            case 'btn-remove':
                this.remove(null);
                break;
        }
    }

    /**
     * 新增行
     */
    abstract add(): void;

    /**
     * 开始行编辑
     * @param ctx 
     */
    startRowEdit(ctx?: { rowIndex: number; rowData: { [key: string]: any; id: any; }; }) {
        this.dg.editRow(ctx.rowData.id);
        this.editingRowId = ctx.rowData.id;
        this.cdf.detectChanges();
        return false;
    }

    /**
     * 取消行编辑
     * @param ctx 
     */
    cancelRowEdit(ctx?: { rowIndex: number; rowData: { [key: string]: any; id: any; }; }) {
        this.dg.cancelEdit(ctx.rowData.id);
        this.editingRowId = null;
        this.cdf.detectChanges();
        return false;
    }

    /**
     * 结束行编辑
     * @param ctx 
     */
    endRowEdit(ctx?: { rowIndex: number; rowData: { [key: string]: any; id: any; }; }) {
        this.dg.endRowEdit();
        this.editingRowId = null;
        this.cdf.detectChanges();
        return false;
    }

    /**
     * 行删除
     * @param ctx 
     */
    remove(evt: Event, ctx?: { rowIndex: number, rowData: { id;[key: string]: any } }) {
        const ids: string[] = [];
        if (ctx == null) {
            // 批量删除
            this.dg.checkeds.forEach(it => {
                ids.push(it.id);
            });
        } else {
            // 行内删除
            ids.push(ctx.rowData.id);
        }
        if (ids.length == 0) {
            this.notify.warning(this.localePipe.instant("pleaseSelectOneItemAtLeast"));
            if (evt != null) {
                evt.stopPropagation();
            }
            return false;
        }
        for (let id of ids) {
            this.dg.deleteRow(id);
        }
        this.dgData = this.dg.data;
        if (this.editingRowId != null) {
            if (ids.includes(this.editingRowId)) {
                this.editingRowId = null;
            } else {
                this.dg.editRow(this.editingRowId);
            }
        }
        this.cdf.detectChanges();
        if (evt != null) {
            evt.stopPropagation();
        }
        return false;
    }

    /**
     * 行移动
     * @param ctx datagrid上下文
     * @param direction -1: 上移， 1：下移
     */
    rowMove(evt: Event, ctx: { rowIndex: number, rowData: { id;[key: string]: any } }, direction: number) {
        // const arr = dg.data;
        const arr = this.dgData;
        const index = this.findIndex(arr, ctx.rowData.id);

        if (index == -1 || (direction == 1 && index == arr.length - 1) || (direction == -1 && index == 0)) {
            return;
        }
        arr[index] = [arr[index + direction], arr[index + direction] = arr[index]][0];
        this.dgData = [...this.dgData];
        this.cdf.detectChanges();
        if (evt != null) {
            evt.stopPropagation();
        }
        return false;
    }

    /**
     * 查找数组中指定id的元素下标
     * @param arr 数组
     * @param id 数组唯一标识
     * @returns 元素下标
     */
    protected findIndex(arr: any[], id): number {
        let index = -1;
        for (let i = 0; i < arr.length; i++) {
            const elt = arr[i];
            if (elt.id == id) {
                index = i;
                break;
            }
        }
        return index;
    }

    abstract load(): void;

    abstract configDgColumns(): void;
}